import React from 'react'

import { GetCustomerCopyFunc, LocationMatcherDisplayFormats } from '@lyrahealth-inc/shared-app-logic'

import {
  DEFAULT_WORKLIFE_SERVICES,
  getCarelonDefaultWorkLifeServices,
  onsiteAlternativeDescription,
  onsiteDescription,
} from './default'
import { BodyText } from '../atoms'
import { WorkLifeIconFamily } from '../atoms/icons/WorkLifeIcons'

export const google: GetCustomerCopyFunc = () => {
  const CARELON_WORKLIFE_SERVICES = getCarelonDefaultWorkLifeServices('abbvie')
  return {
    locationFinder: {
      onsiteFormat: LocationMatcherDisplayFormats.DROPDOWN_MENU_TO_RADIO_BUTTONS,
      onsiteDescription: (
        <>
          <BodyText>{onsiteDescription}</BodyText>
          <BodyText>{onsiteAlternativeDescription}</BodyText>
        </>
      ),
    },
    workLifeServices: [
      {
        ...DEFAULT_WORKLIFE_SERVICES.LEGAL_SERVICES,
        PATH: 'https://www.clcmembers.net/organizations/7cf62110-838b-11eb-b582-4fcc775e1c8f',
      },
      {
        identifiers: {
          id: 'brightHorizons',
          dataTestId: 'workLife-selectBrightHorizons',
        },
        title: 'Bright Horizons',
        iconSvg: <WorkLifeIconFamily size={48} />,
        paragraph: '',
        bullets: [
          'Help finding caregiving support for infants to elders',
          'Backup care when regular arrangements fall through',
          'Educational resources and tutoring discounts',
        ],
        CTA: 'Access Bright Horizons',
        PATH: 'https://clients.brighthorizons.com/abbvie',
      },
      {
        ...DEFAULT_WORKLIFE_SERVICES.IDENTITY_THEFT,
        PATH: 'https://www.clcmembers.net/organizations/7cf62110-838b-11eb-b582-4fcc775e1c8f',
      },
      DEFAULT_WORKLIFE_SERVICES.DEPENDENT_CARE,
    ],
    carelonWorkLifeServices: [
      CARELON_WORKLIFE_SERVICES.LEGAL_SERVICES,
      {
        identifiers: {
          id: 'brightHorizons',
          dataTestId: 'workLife-selectBrightHorizons',
        },
        title: 'Bright Horizons',
        iconSvg: <WorkLifeIconFamily size={48} />,
        paragraph: '',
        bullets: [
          'Help finding caregiving support for infants to elders',
          'Backup care when regular arrangements fall through',
          'Educational resources and tutoring discounts',
        ],
        CTA: 'Access Bright Horizons',
        PATH: 'https://clients.brighthorizons.com/abbvie',
      },
      CARELON_WORKLIFE_SERVICES.IDENTITY_THEFT,
      CARELON_WORKLIFE_SERVICES.DEPENDENT_CARE,
    ],
  }
}
